import { ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import AtInputLabel from '../atoms/AtInputLabel';
import AtPasswordBox from '../atoms/AtPasswordBox';

/** 属性定義 */
type Props = {
  children: ReactNode;
  id: string;
  name: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  register?: UseFormRegisterReturn;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const MlLabeledPasswordBox = ({
  children,
  id,
  name,
  className,
  labelClassName,
  inputClassName,
  defaultValue,
  placeholder,
  disabled,
  maxLength,
  minLength,
  register
}: Props) => {
  return <div className={`mllabeledpasswordbox ${className}`}>
      <div className='flex'>
        <AtInputLabel className={labelClassName} htmlFor={id}>
          {children}
        </AtInputLabel>
        <AtPasswordBox id={id} name={name} defaultValue={defaultValue} className={inputClassName} placeholder={placeholder} disabled={disabled} maxLength={maxLength} minLength={minLength} register={register} />
      </div>
    </div>;
};
/** 初期値の設定 */
MlLabeledPasswordBox.defaultProps = {
  className: '',
  labelClassName: '',
  inputClassName: '',
  defaultValue: null,
  placeholder: null,
  disabled: false,
  maxLength: null,
  minLength: null,
  register: null
};
export default MlLabeledPasswordBox;